import React, { FC, useContext } from 'react';

import { SettingsBlock, SettingsFrame } from 'components';
import { LocalizationContext } from 'localization';

import { EndSession, TurningOffPC } from './components';

export const PowerManagement: FC = () => {
  const { t } = useContext(LocalizationContext);
  return (
    <>
      <SettingsBlock title={t('settings.shell.power_manager.title')}>
        <SettingsFrame>
          <EndSession />
        </SettingsFrame>

        <SettingsFrame>
          <TurningOffPC />
        </SettingsFrame>
      </SettingsBlock>
    </>
  );
};
